import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { homeRouteFor } from './transportista-allowlist';

export const roleGuard = (allowedRoles: string[]) => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      router.navigate(['/authentication/sign-in']);
      return false;
    }

    const currentUser = authService.getCurrentUser();
    if (!currentUser) {
      router.navigate(['/authentication/sign-in']);
      return false;
    }

    // Verificar si el usuario tiene alguno de los roles permitidos
    const hasAllowedRole = currentUser.roles.some(role => allowedRoles.includes(role));
    
    if (hasAllowedRole) {
      return true;
    } else {
      // Redirigir a la página principal si no tiene permisos (el transportista no tiene /home)
      return router.parseUrl(homeRouteFor(authService));
    }
  };
}; 